import React, { Suspense, useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import genStyles from "../../generale.module.css";
import { boolModifState, collectionsCurState, idLayerEditState, localDataState, markerFormEditState, typeCollectionState } from "../../../atoms/CollectionState";
import { DropdownSelect } from "../../dropdownSelect";
import DrawService from "../../../service/DrawService";
import ReactSwitch from "react-switch";
import ShowService from "../../../service/showService";
import FileForm from "./fileForm";
import TooltipForm from "../../tooltipForm";
import FullScreenModal from "../../modalForm/fullScreenModal";
const EditorForm = React.lazy(() => import("../../editorForm"));

export default function CircleForm({setEntiteslist, openEntityList, deleteEntityList, objectCur, returnToEntityList, collectionName}) {
    const [form, setForm] = useRecoilState(markerFormEditState);
    const layerEdit = useRecoilValue(idLayerEditState);
    const [switchColor, setSwitchColor] = useState('#86d3ff');
    const collectioncur = useRecoilValue(collectionsCurState);
    const typeCollection = useRecoilValue(typeCollectionState);  
    const LocalData = useRecoilValue(localDataState); 
    const [nomCreateur, setNomCreateur] = useState('');    
    const [nomModif, setNomModif] = useState('');    
    const [dateModif, setDateModif] = useState('');    
    const setBoolModif = useSetRecoilState(boolModifState); 
    const [showEditor, setShowEditor] = useState(false); 
    const [overlayTop, setOverlayTop] = useState(0);
    const headerRef = useRef(null);
    
    useEffect(() => {
        if(headerRef.current){
            setOverlayTop(headerRef.current.getBoundingClientRect().bottom);
        }
    
        if(!LocalData){
            setNomCreateur(objectCur?.sogefi_nom_creation ?? 'Utilisateur inconnu');
            setNomModif(objectCur?.sogefi_nom_modification ?? 'Utilisateur inconnu');
            if (objectCur?.sogefi_date_modification) {
                setDateModif(objectCur.sogefi_date_modification);
            }         
        }
    
        // Récupérer la variable CSS définie dans :root
        const color = getComputedStyle(document.documentElement)
          .getPropertyValue('--main-color-first')
          .trim();
        if (color) {
            const formatcolor = ShowService.getColorFormat(color);
            switch (formatcolor) {
                case 'hex':
                    setSwitchColor(color);
                  break;
                case 'rgba':
                case 'rgb':
                    setSwitchColor(ShowService.rgbToHex(color));
                  break;
                  default : setSwitchColor('#86d3ff');
            }
          
        }
    }, []);

    const updateField = (key, value) => {
        setBoolModif(true);
        setForm((prev) => {
            let updatedValue = value;

            // Si on modifie la transparence, convertir % en valeur 0-1
            if (key === "polycontourOpacity" || key === "polyOpacity") {
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue)) {
                    updatedValue = numericValue / 100;
                } else {
                    updatedValue = 0;
                }
            }
            const updatedForm = { ...prev, [key]: updatedValue };
            const updatedLayer = DrawService.updatePropertieLayer(updatedForm, layerEdit,'polygon');            
            if (updatedLayer) {                
                const updatedGeoJSON = updatedLayer.toGeoJSON();                
                const updatedGeom = JSON.stringify(updatedGeoJSON.geometry);
                updatedGeoJSON.properties = updatedLayer.data;

                setEntiteslist((prevList) => {
                    const updatedList = prevList.map((entity) => {
                        if (entity.id === updatedLayer.data.id) {
                            const updatedEntity = { 
                                ...entity, 
                                geojson: updatedGeoJSON,
                                geom : updatedGeom,
                                tag:updatedLayer.data.tag,
                                measure:updatedLayer.data.measure,
                                titre:updatedLayer.data.titre,
                                observation:updatedLayer.data.observation,
                            };
                            return updatedEntity;
                        }
                        return entity;
                    });
                    return updatedList;
                });
            }
            return updatedForm;
        });
    };

    // Fonction pour vérifier si une date correspond à aujourd'hui
    const isToday = (dateStr) => {
        if (!dateStr) return false;
        const date = new Date(dateStr.replace(" ", "T"));
        const today = new Date();
        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
    };

    // Fonction pour formater une date avec "aujourd'hui" si nécessaire
    const formatDateWithToday = (dateStr) => {
        if (!dateStr) return "";
        if (isToday(dateStr)) {
            // Extraire l'heure de la date
            const date = new Date(dateStr.replace(" ", "T"));
            const heures = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `aujourd'hui à ${heures}h${minutes}`;
        }
        return ShowService.formatDate(dateStr);
    };

    const getEntityInfo = () => {
        if (!objectCur.sogefi_date) return "";
        const dateCreation = formatDateWithToday(objectCur.sogefi_date);
        const isCreationToday = isToday(objectCur.sogefi_date);
        const prefixCreation = isCreationToday ? "" : "le ";
        let infoText = `Créé par ${nomCreateur} ${prefixCreation}${dateCreation}`;
        if (nomModif && dateModif) {
            const dateModifFormatted = formatDateWithToday(dateModif);
            const isModifToday = isToday(dateModif);
            const prefixModif = isModifToday ? "" : "le ";
            infoText += `\n\nDernière modification par ${nomModif} ${prefixModif}${dateModifFormatted}`;
        }
        return infoText;
    };

    const setZoomEntity = () => {
        const geojson = objectCur?.geojson;
        ShowService.addEntitesToMap(geojson,'zoom');
    };

    const presetColors = [
        { name: "#36c980", iconClass: "#36c980" },
        { name: "#a0d44f", iconClass: "#a0d44f" },
        { name: "#c9b957", iconClass: "#c9b957" },
        { name: "#face47", iconClass: "#face47" },
        { name: "#7945ca", iconClass: "#7945ca" },
        { name: "#a15bd5", iconClass: "#a15bd5" },
        { name: "#6499f4", iconClass: "#6499f4" },
        { name: "#76cbf9", iconClass: "#76cbf9" },
        { name: "#b63453", iconClass: "#b63453" },
        { name: "#db465e", iconClass: "#db465e" },
        { name: "#f61e87", iconClass: "#f61e87" },
        { name: "#f75cbf", iconClass: "#f75cbf" },
        { name: "#f7683c", iconClass: "#f7683c" },
        { name: "#f7af54", iconClass: "#f7af54" },
        { name: "#7d5247", iconClass: "#7d5247" },
        { name: "#818181", iconClass: "#818181" },
        { name: "#252525", iconClass: "#252525" },
        { name: "#FFFFFF", iconClass: "#FFFFFF" },
    ];
    return (
        <> 
            <div className={genStyles.buttonheaderfrm} ref={headerRef}>
            {(typeCollection == 'collection' || collectioncur.edit) && (
            <>
                <TooltipForm content="Supprimer l'entité">
                    <button
                        className="btn-floating red lighten-1"
                        onClick={deleteEntityList}
                    >
                        <i className="fa-solid fa-trash"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content="Enregistrer les modifications">
                    <button
                        className="btn-floating green lighten-1"
                        onClick={openEntityList}
                    >
                        <i className="fa-solid fa-floppy-disk"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={`Zoomer sur l'entité`}>
                    <button
                        className="btn-floating yellow darken-3"
                        onClick={setZoomEntity}
                    >
                        <i className="fa-solid fa-magnifying-glass-plus"></i>
                    </button>
                </TooltipForm>
                <TooltipForm content={getEntityInfo()}>
                    <button
                        className="btn-floating grey lighten-1"
                    >
                        <i className="fa-solid fa-info"></i>
                    </button>
                </TooltipForm>
            </>
            )}
            </div>
        
        <div className={`${genStyles.editFormContainer} scroller`}>
            <div className={genStyles.editFormSection}>
                {/* --- Info générale --- */}
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-square-info ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Information générale
                    </span>
                </div>
                <div className="row mb0">
                    <div className="col s12 mb20">
                        <span className={`${genStyles.fontSize15} black-text`}>
                        Nom de l'entité
                        </span>
                        <input
                        className={genStyles.inputtCol}
                        type="text"
                        placeholder="Donner un nom à votre entité"
                        value={form.nomEntite}
                        maxLength={50}
                        onChange={(e) => updateField("nomEntite", e.target.value)}
                        />
                    </div>

                    <div className={`col s12 mb10 ${genStyles.ctnswitch}`}>
                        <span className={`${genStyles.fontSize15} black-text`}>
                        Afficher le nom sur la carte
                        </span>
                        <ReactSwitch
                            onChange={(checked) => updateField("tag", checked)}
                            checked={!!form.tag}
                            onColor={switchColor}
                            offColor="#bbbbbb"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={20}
                            width={40}
                        />
                    </div>

                    <div className="col s12 mb0">
                        <span className={`${genStyles.fontSize15} black-text`}>
                        Observation <i className={`fa-solid fa-pencil ${genStyles.fontSize16} ${genStyles.icomarginObserv}`} onClick={() => setShowEditor(true)}></i>
                        </span>
                        <div
                            className={`${genStyles.observationPreview}`}
                            dangerouslySetInnerHTML={{ __html: form.observation}}
                        />
                    </div>
                </div>
            </div>

            {/* --- Paramètres géographiques --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa fa-circle ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                        Paramètres géographiques
                    </span>
                </div>
                <div className="row mb0">
                    <div className="col s6">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Rayon (m)</span>
                        <input
                            className={genStyles.inputtCol}
                            type="number"
                            min="0"
                            step="0.001"
                            value={
                                form.radius !== undefined && form.radius !== null && form.radius !== ""
                                ? parseFloat(parseFloat(form.radius).toFixed(3)).toString()
                                : ""
                            }
                            onChange={(e) => {
                                const val = parseFloat(e.target.value);
                                if (!isNaN(val)) {
                                updateField("radius", val);
                                } else {
                                updateField("radius", "");
                                }
                            }}
                        />
                    </div>
                    <div className={`col s6 `}>
                        <div className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>
                            Afficher la surface
                        </div>
                        <ReactSwitch
                            onChange={(checked) => updateField("measure", checked)}
                            checked={!!form.measure}
                            onColor={switchColor}
                            offColor="#bbbbbb"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={20}
                            width={40}
                        />
                    </div>
                </div>
            </div>

            {/* --- Style --- */}
            <div className={genStyles.editFormSection}>
                <div className={genStyles.titleedsection}>
                    <i className={`fa-solid fa-palette ${genStyles.fontSize18} ${genStyles.icomargin}`}></i>
                    <span className={`${genStyles.fontSize16} ${genStyles.bold} ${genStyles.bgcolorfirsttext}`}>
                    Styles
                    </span>
                </div>
                <div className="row mb10">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Contour</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polycontourColor}
                                onChange={(color) => updateField("polycontourColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polycontourColor}
                                onChange={(e) => updateField("polycontourColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Opacité</span>
                        <div className={genStyles.pickctn}>
                            <input 
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polycontourOpacity !== '' ? (form.polycontourOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polycontourOpacity", e.target.value)}
                            />                            
                            <span> %</span>
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Épaisseur</span>
                        <input 
                            className={genStyles.inputtCol}
                            type="number"
                            min="0"
                            value={form.polycontourEpaisseur}
                            onChange={(e) => updateField("polycontourEpaisseur", e.target.value)}
                        />
                    </div>
                </div>   
                <div className="row mb0">
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Remplissage</span>
                        <div className={genStyles.pickctn}>
                            <DropdownSelect
                                options={presetColors}
                                selected={form.polyColor}
                                onChange={(color) => updateField("polyColor", color)}
                                type="color"
                                showCustomColor={true}
                            />                               
                            <input 
                                className={genStyles.inputtCol}
                                type="text"
                                value={form.polyColor}
                                onChange={(e) => updateField("polyColor", e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="col s4">
                        <span className={`${genStyles.fontSize15}  black-text  ${genStyles.noMargin}`}>Opacité</span>
                        <div className={genStyles.pickctn}>
                            <input 
                                className={genStyles.inputtCol}
                                type="number"
                                min="0"
                                max="100"
                                value={form.polyOpacity !== '' ? (form.polyOpacity * 100).toFixed(0) : ''}
                                onChange={(e) => updateField("polyOpacity", e.target.value)}
                            />
                            <span> %</span>
                        </div>
                    </div>
                </div>                  
            </div>

            {!LocalData && (
                <FileForm objectCur={objectCur} setEntites={setEntiteslist} />
            )}

        </div>

        
        {/* Div overlay pour bloquer et griser */}
        {typeCollection === "shared" && (!collectioncur?.edit) && (
            <div className={genStyles.ctnDisabled} style={{ top: overlayTop }} />
        )}
        
        {showEditor && (
            <FullScreenModal>
                <Suspense fallback={<div>Chargement de l’éditeur...</div>}>
                    <EditorForm value={form.observation}  onChange={(html) => updateField("observation", html)} onClose={() => setShowEditor(false)} />
                </Suspense>
            </FullScreenModal>        
        )}
        </>
    );
}
